<script lang="ts" setup>
import { i18n } from '@/i18n';
import { computed } from 'vue';

const t = i18n.t;

const props = withDefaults(
  defineProps<{
    isCreated?: boolean;
  }>(),
  {
    isCreated: false,
  }
);

const computedClass = computed(() => {
  return props.isCreated ? 'creation-status--created' : 'creation-status--not-created';
});

const displayText = computed(() => {
  return props.isCreated ? t('仕入先内示作成ステータス:完了') : t('仕入先内示作成ステータス:未完了');
});
</script>

<template>
  <div class="creation-status" :class="computedClass">
    {{ displayText }}
  </div>
</template>

<style scoped lang="scss">
.creation-status {
  width: 80px;
  padding-top: 4px;
  padding-bottom: 4px;
  border-radius: 90px;
  border: 1px solid;
  font: Noto Sans JP;
  letter-spacing: 0;
  white-space: nowrap;
  font-weight: 700;
  font-size: 11px;
  line-height: 11px;

  &--not-created {
    background-color: $semanticWhite;
    border-color: $borderSecondary;
    color: $textSecondary;
  }

  &--created {
    background-color: $semanticSuccess;
    border-color: $semanticSuccess;
    color: $semanticWhite;
  }
}
</style>
